// Audio playback action types
export const PLAY_TRACK_REQUEST = 'audio/PLAY_TRACK_REQUEST';
export const PLAY_TRACK_SUCCESS = 'audio/PLAY_TRACK_SUCCESS';
export const PLAY_TRACK_FAILURE = 'audio/PLAY_TRACK_FAILURE';

export const PAUSE_TRACK = 'audio/PAUSE_TRACK';
export const RESUME_TRACK = 'audio/RESUME_TRACK';
export const STOP_TRACK = 'audio/STOP_TRACK';

export const PLAY_NEXT_TRACK = 'audio/PLAY_NEXT_TRACK';
export const PLAY_PREVIOUS_TRACK = 'audio/PLAY_PREVIOUS_TRACK';

export const UPDATE_PLAYBACK_PROGRESS = 'audio/UPDATE_PLAYBACK_PROGRESS';
export const SEEK_TO_POSITION = 'audio/SEEK_TO_POSITION';

export const SEND_PLAYBACK_HEARTBEAT_REQUEST = 'audio/SEND_PLAYBACK_HEARTBEAT_REQUEST';
export const SEND_PLAYBACK_HEARTBEAT_SUCCESS = 'audio/SEND_PLAYBACK_HEARTBEAT_SUCCESS';
export const SEND_PLAYBACK_HEARTBEAT_FAILURE = 'audio/SEND_PLAYBACK_HEARTBEAT_FAILURE';

export const LOAD_TOUR_TRACKS = 'audio/LOAD_TOUR_TRACKS';
export const SET_CURRENT_TOUR = 'audio/SET_CURRENT_TOUR';
